var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-field",
    class: {
      'full': _vm.isFull
    },
    style: ({
      width: _vm.width,
      height: _vm.height
    })
  }, [(_vm.editable) ? _c('div', {
    staticClass: "image-field__dropzone"
  }, [_c('div', {
    staticClass: "image-field__prompt dz-message"
  }, [_c('span', {
    staticClass: "ss-icon"
  }, [_vm._v("upload")]), _vm._v(" "), _c('span', {
    staticClass: "image-field__message"
  }, [_vm._v(_vm._s(_vm.currentMessage))]), _vm._v(" "), (_vm.recommendations) ? _c('span', {
    staticClass: "image-field__recommendations"
  }, [_vm._v(_vm._s(_vm.recommendations))]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "fileSelect",
    staticClass: "image-field__file",
    class: {
      'val-required': _vm.isRequired
    },
    attrs: {
      "id": _vm.inputId,
      "name": _vm.paramName,
      "type": "file",
      "accept": "image/*",
      "required": _vm.isRequired
    },
    on: {
      "change": _vm.readFile
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "image-field__remove_file",
    attrs: {
      "type": "hidden",
      "name": _vm.removeParamName()
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue && !_vm.showDropzone),
      expression: "currentValue && !showDropzone"
    }],
    ref: "img",
    staticClass: "image-field__preview",
    attrs: {
      "src": _vm.currentValue
    }
  })]), _vm._v(" "), (_vm.showControls) ? _c('div', {
    staticClass: "image-field__controls"
  }, [(_vm.editable) ? _c('button', {
    staticClass: "image-field__edit ss-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleDropzone($event)
      }
    }
  }, [_vm._v("upload")]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.removable) ? _c('button', {
    staticClass: "image-field__remove ss-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeFile($event)
      }
    }
  }, [_vm._v("delete")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2601cc0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/image-field.vue
// module id = null
// module chunks = 